import { ReactNode } from "react";
import ViewController from "../../commons/base/view_controller";
import Scaffold from "../../commons/scaffold/scaffold";
import SizedDiv from "../../commons/ui/sized_div";
import TableSOForms from "./widgets/table_so_forms";
import TableSOItems from "./widgets/table_so_items";
import "./style.css";
import SoScreenViewModel from "./view_models/so_screen_view_model";
import LocationSelection from "./widgets/location_selection";
import FormButton from "../../commons/ui/form_button";
import SoScreenState from "./view_models/so_screen_state";

interface Props {}

export default class SoScreen extends ViewController<
    Props,
    SoScreenState,
    SoScreenViewModel
> {
    constructor(props: Props) {
        super(props, new SoScreenViewModel());
    }

    componentDidMount(): void {
        window.addEventListener("popstate", (e) => {
            if (this.vmState.selectedLocationId !== undefined) {
                // previous page was the history table
                e.preventDefault();
                this.toLocationSelection();
            } else {
                window.history.back();
            }
        });
    }

    setSelectedFormState(formId: number) {
        this.viewModel.emit((lastState) => {
            lastState.selectedForm = formId;
            this.viewModel.updateTables();
            return lastState;
        })
    }

    toLocationSelection() {
        this.viewModel.resetAllState();
        const host = window.location.host.slice(0, window.location.host.length);
        const pathname = window.location.pathname;
        const newUrl = `http://${host}${pathname}`;
        window.history.pushState({path: newUrl}, "",newUrl);
    }

    renderMainContent(): ReactNode {
        return this.vmState.selectedLocationId
        ?   <div id="SoScreenContainer">
                <div>
                    <div id="SoHistoryContainer">
                        <SizedDiv height={100} />
                        <p className="FormTitle">
                            Riwayat Submit Form SO {this.vmState.selectedLocation}
                        </p>
                        <SizedDiv height={30} />
                        <div style={{display: "flex", alignItems: "start"}}>
                            <FormButton
                                action={(e) => {
                                    e.preventDefault();
                                    this.toLocationSelection();
                                }}
                                title="Kembali"
                                backgroundColor="#58BAD7"
                                textColor="#FFF"
                                borderColor="#FFF"
                            />
                        </div>
                        <SizedDiv height={30} />
                        <div className="FormTableContainer">
                            <TableSOForms 
                                location={this.vmState.selectedLocationId}
                                forms={this.vmState.soForms} 
                                onBtnViewItemsClicked={(formId: number) => {
                                    this.setSelectedFormState(formId);
                                }}/>
                        </div>
                    </div>
                    <div id="SoItemsContainer">
                        <p style={{fontWeight: "bold", fontSize: 24}}>
                            Daftar Item Pada Form SO #{this.vmState.selectedForm}
                        </p>
                        <div className="ItemTableContainer">
                            <TableSOItems formItems={this.vmState.soFormItems}/>
                        </div>
                    </div>
                </div>
            </div>
        :   <div id="LocationSelectionContainer">
                <div>
                    <p className="FormTitle">
                        Pilih Lokasi Riwayat Supply Opname
                    </p>
                    <SizedDiv height={30} />
                    <LocationSelection vc={this}/>
                </div>
            </div>  
    }

    render(): ReactNode {
        return (
            <>
                <Scaffold>
                    {this.renderMainContent()}
                </Scaffold>
            </>
        );
    }
}
